// Support Configuration
export const supportConfig = {
  koFi: {
    url: 'https://ko-fi.com/migspsalm91studio', // Replace with your Ko-fi username
    label: 'Support on Ko-fi',
    icon: '☕'
  },
  contact: {
    email: 'officialpsalm91studio@gmail.com',
    // Obfuscated email parts for spam protection
    emailParts: {
      user: 'officialpsalm91studio',
      domain: 'gmail.com'
    }
  },
  about: {
    title: 'About This Study',
    description: 'This interactive Bible study presentation on Daniel Chapter 7 explores the vision of the four beasts and their prophetic significance for understanding world history and God\'s eternal kingdom.'
  }
}

// Email obfuscation function to prevent spam
export const getObfuscatedEmail = (): string => {
  const { user, domain } = supportConfig.contact.emailParts
  return `${user}@${domain}`
}

// Create secure mailto link with additional spam protection
export const getSecureMailtoLink = (): string => {
  const email = getObfuscatedEmail()
  const subject = encodeURIComponent('Bible Study Presentation Inquiry')
  const body = encodeURIComponent('Hello,\n\nI have a question about your Bible study presentations...')
  return `mailto:${email}?subject=${subject}&body=${body}`
}